import { Grid as ChakraGrid } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { GridSharedProps } from "./Grid.props";

type ChakraGridProps = ComponentProps<typeof ChakraGrid>;

export type GridProps = GridSharedProps & {
  // Add any web specific props here.
};

export default function Grid(props: GridProps): JSX.Element {
  return <ChakraGrid {...(props as unknown as ChakraGridProps)} />;
}
